export interface SponsorItem {
  name: string;
  category: string;
  logoSrc: string;
  tierRank: number;
  website?: string;
  description?: string;
}

export interface PartnerItem {
  name: string;
  type: 'association' | 'media' | 'international_council';
  logoSrc: string;
  website?: string;
}

export const countryPartner: SponsorItem = {
  name: 'UK Government / GREAT',
  category: 'Country Partner',
  logoSrc: 'https://iiabexpo.com/images/GREAT.png',
  tierRank: 1,
  description: 'Department for Business and Trade, British High Commission — Bilateral South Asia AgriTech Partner',
};

export const categorizedSponsors: Record<string, SponsorItem[]> = {
  sammelanBag: [
    {
      name: 'Bayer CropScience',
      category: 'Sammelan - Official Conference Bag Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/bayer-1782469701.png',
      tierRank: 2,
    },
  ],
  lekhanPenPad: [
    {
      name: 'Lekhan Pen & Pad',
      category: 'Lekhan - Official Stationery & Pen Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/lekhan-pen-pad-1784266361.webp',
      tierRank: 3,
    },
  ],
  utsavBhojDinner: [
    {
      name: 'Crystal Crop Care',
      category: 'Utsav Bhoj - Gala Networking Dinner Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/crystal-crop-care-1782415802.webp',
      tierRank: 2,
    },
  ],
  aahaarFnB: [
    {
      name: 'P J Margo',
      category: 'Aahaar - Conference F&B Hospitality Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/p-j-margo-1782415832.webp',
      tierRank: 3,
    },
  ],
  samvaadTeaCoffee: [
    {
      name: 'Scimplify',
      category: 'Samvaad - Networking Coffee & Tea Lounge Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/scimplify-1782415853.webp',
      tierRank: 3,
    },
  ],
  samriddhGold: [
    {
      name: 'Baroda Agri',
      category: 'Samriddh - Gold Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/baroda-agri-1782484942.webp',
      tierRank: 4,
    },
    {
      name: 'Ayvens',
      category: 'Samriddh - Gold Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/ayvens-1782482479.webp',
      tierRank: 4,
    },
    {
      name: 'Dhana Crop Sciences',
      category: 'Samriddh - Gold Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/dhana-1784264531.png',
      tierRank: 4,
    },
    {
      name: 'Privi Life Sciences',
      category: 'Samriddh - Gold Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/privi-1782482509.webp',
      tierRank: 4,
    },
    {
      name: 'Verdesian Life Sciences',
      category: 'Samriddh - Gold Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/verdesian-1782482876.webp',
      tierRank: 4,
    },
  ],
  uttamSilver: [
    {
      name: 'Heranba Industries',
      category: 'Uttam - Silver Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/heranba-1782415656.webp',
      tierRank: 5,
    },
    {
      name: 'Mahamaya Lifesciences',
      category: 'Uttam - Silver Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/mahamaya-1782482653.webp',
      tierRank: 5,
    },
    {
      name: 'Momentive Performance Materials',
      category: 'Uttam - Silver Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/momentive-1782415758.webp',
      tierRank: 5,
    },
  ],
  paramBronze: [
    {
      name: 'Sathyam Biotech',
      category: 'Param - Bronze Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/sathyam-1782482620.webp',
      tierRank: 6,
    },
    {
      name: 'T.Stanes & Company',
      category: 'Param - Bronze Sponsor',
      logoSrc: 'https://iiabexpo.com/uploads/sponsors/t-stanes-1782482588.webp',
      tierRank: 6,
    },
  ],
};

export const allSponsorsList: SponsorItem[] = [
  countryPartner,
  ...Object.values(categorizedSponsors).flat(),
];

export interface ExperientialSponsorItem extends SponsorItem {
  entitlementTitle: string;
  entitlementBadge: string;
  entitlementIcon: 'dinner' | 'bag' | 'hospitality' | 'lounge' | 'stationery';
}

export const experientialSponsors: ExperientialSponsorItem[] = [
  {
    ...categorizedSponsors.utsavBhojDinner[0],
    entitlementTitle: 'Gala Networking Dinner Sponsor',
    entitlementBadge: 'Utsav Bhoj',
    entitlementIcon: 'dinner',
  },
  {
    ...categorizedSponsors.sammelanBag[0],
    entitlementTitle: 'Official Conference Bag Sponsor',
    entitlementBadge: 'Sammelan',
    entitlementIcon: 'bag',
  },
  {
    ...categorizedSponsors.aahaarFnB[0],
    entitlementTitle: 'Conference F&B Hospitality Sponsor',
    entitlementBadge: 'Aahaar',
    entitlementIcon: 'hospitality',
  },
  {
    ...categorizedSponsors.samvaadTeaCoffee[0],
    entitlementTitle: 'Coffee & Tea Lounge Sponsor',
    entitlementBadge: 'Samvaad',
    entitlementIcon: 'lounge',
  },
  {
    ...categorizedSponsors.lekhanPenPad[0],
    entitlementTitle: 'Official Stationery & Pen Sponsor',
    entitlementBadge: 'Lekhan',
    entitlementIcon: 'stationery',
  },
];

export const goldSponsors: SponsorItem[] = categorizedSponsors.samriddhGold;
export const silverSponsors: SponsorItem[] = categorizedSponsors.uttamSilver;
export const bronzeSponsors: SponsorItem[] = categorizedSponsors.paramBronze;

export const industryPartners: PartnerItem[] = [
  {
    name: 'CropLife India',
    type: 'association',
    logoSrc: 'https://iiabexpo.com/uploads/partners/croplife-1782463369.webp',
  },
  {
    name: 'BIPA (Bio-Inputs Producers Association)',
    type: 'association',
    logoSrc: 'https://iiabexpo.com/uploads/partners/bipa-1782463352.webp',
  },
  {
    name: 'BASAI (Biological Agri Solutions Association of India)',
    type: 'association',
    logoSrc: 'https://iiabexpo.com/uploads/partners/basai-1782460960.png',
  },
  {
    name: 'IMMA (Indian Micronutrient Manufacturers Association)',
    type: 'association',
    logoSrc: 'https://iiabexpo.com/uploads/partners/imma-1782463397.webp',
  },
  {
    name: 'CBPC (China Biostimulants Professional Committee)',
    type: 'international_council',
    logoSrc: 'https://iiabexpo.com/uploads/partners/china-biostimulants-professional-committee---cbpc-1782463359.webp',
  },
  {
    name: 'Agri Brasilis',
    type: 'media',
    logoSrc: 'https://iiabexpo.com/uploads/partners/agri-brasilis-1782463305.webp',
  },
  {
    name: 'Agrowon (Sakal Media)',
    type: 'media',
    logoSrc: 'https://iiabexpo.com/uploads/partners/agrowon-1783492267.webp',
  },
  {
    name: 'Krishi Jagran',
    type: 'media',
    logoSrc: 'https://iiabexpo.com/uploads/partners/krishi-jagran-1782463412.webp',
  },
];

export interface PastSponsorItem {
  name: string;
  pastTier: string;
  logoSrc: string;
}

export const pastEditionSponsors: PastSponsorItem[] = [
  {
    name: 'UK Government / GREAT',
    pastTier: 'Past Country Partner',
    logoSrc: 'https://iiabexpo.com/images/GREAT.png',
  },
  {
    name: 'Bayer CropScience',
    pastTier: 'Past Bag Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/bayer-1782469701.png',
  },
  {
    name: 'Crystal Crop Care',
    pastTier: 'Past Dinner Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/crystal-crop-care-1782415802.webp',
  },
  {
    name: 'Baroda Agri',
    pastTier: 'Past Gold Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/baroda-agri-1782484942.webp',
  },
  {
    name: 'Ayvens',
    pastTier: 'Past Gold Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/ayvens-1782482479.webp',
  },
  {
    name: 'Dhana Crop Sciences',
    pastTier: 'Past Gold Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/dhana-1784264531.png',
  },
  {
    name: 'Privi Life Sciences',
    pastTier: 'Past Gold Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/privi-1782482509.webp',
  },
  {
    name: 'Verdesian Life Sciences',
    pastTier: 'Past Gold Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/verdesian-1782482876.webp',
  },
  {
    name: 'Heranba Industries',
    pastTier: 'Past Silver Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/heranba-1782415656.webp',
  },
  {
    name: 'Mahamaya Lifesciences',
    pastTier: 'Past Silver Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/mahamaya-1782482653.webp',
  },
  {
    name: 'Momentive Performance Materials',
    pastTier: 'Past Silver Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/momentive-1782415758.webp',
  },
  {
    name: 'Scimplify',
    pastTier: 'Past Lounge Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/scimplify-1782415853.webp',
  },
  {
    name: 'P J Margo',
    pastTier: 'Past Hospitality Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/p-j-margo-1782415832.webp',
  },
  {
    name: 'Sathyam Biotech',
    pastTier: 'Past Bronze Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/sathyam-1782482620.webp',
  },
  {
    name: 'T.Stanes & Company',
    pastTier: 'Past Bronze Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/t-stanes-1782482588.webp',
  },
  {
    name: 'Lekhan Pen & Pad',
    pastTier: 'Past Stationery Sponsor',
    logoSrc: 'https://iiabexpo.com/uploads/sponsors/lekhan-pen-pad-1784266361.webp',
  },
];

export default {
  countryPartner,
  categorizedSponsors,
  allSponsorsList,
  experientialSponsors,
  goldSponsors,
  silverSponsors,
  bronzeSponsors,
  industryPartners,
  pastEditionSponsors,
};

